import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cx from 'classnames';

import { ConfirmType } from 'constants/constants';
import Modal, { ModalContent, ModalTitle, ModalSubtitle, ModalActions, ModalHeader, } from "components/Modal";
import { Button, CancelButton, DeleteButton, SaveButton } from "components/Button";
import UIState from "../store/UIState";

const selectors = createSelector([],
  () => ({})
);



// ===========================
// COMPONENT
// ===========================

let ConfirmModal = ({ title, message, subtitle, content, confirmText = "Ok", confirmType = ConfirmType.DEFAULT, cancelText = "Cancel", onCancel, onClose, onConfirm, onDone, }) => {
  title = title ?? message;
  
  const onConfirmClick = () => {
    onConfirm?.();
    onClose?.();
  }

  const onCancelClick = () => {
    onCancel?.();
    onClose?.();
  }

  let confirmButton;
  switch(confirmType) {
    case ConfirmType.DELETE:
      confirmButton = <DeleteButton size="l" onClick={onConfirmClick} variant="danger">{ confirmText }</DeleteButton>;
      break;
    case ConfirmType.SAVE:
      confirmButton = <SaveButton size="l" onClick={onConfirmClick} variant="success">{ confirmText }</SaveButton>;
      break;
    default:
      confirmButton = <Button size="l" onClick={onConfirmClick}>{ confirmText }</Button>;
  }
    
  return (
    <Modal className="confirm" onClose={onClose}>
      <ModalHeader>
        {title && 
        <ModalTitle>{ title }</ModalTitle>}
        {subtitle && 
        <ModalSubtitle>{ subtitle }</ModalSubtitle>}
      </ModalHeader>
      { content && 
      <ModalContent align="center">{ content }</ModalContent>}
      <ModalActions dir="row">
        { onCancel && 
        <CancelButton size="l" onClick={onCancelClick}>{ cancelText }</CancelButton>}
        { confirmButton}
      </ModalActions>
    </Modal>
  );
  
}

export default ConfirmModal;
